<template>
	<div>
		<div class="container-fluid">
			<div class="row">
				<div class="col-lg-12">
					<environment-card title="ENVIRONMENT"></environment-card>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { EnvironmentCard } from "@/components/index";
export default {
	name: 'environment',
	components: {
		EnvironmentCard
	},
	data() {
		return {
		}
	},
	computed: {

	},
	methods: {
		name() {

		}
	},
}
</script>

<style lang="scss" scoped>

</style>
